import { render, staticRenderFns } from "./placard_order.vue?vue&type=template&id=e787cf06&scoped=true"
import script from "./placard_order.vue?vue&type=script&lang=js"
export * from "./placard_order.vue?vue&type=script&lang=js"
import style0 from "./placard_order.vue?vue&type=style&index=0&id=e787cf06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e787cf06",
  null
  
)

export default component.exports